import mobile from "../../assets/images/Custom-mobile-development@2x.png"
import web from "../../assets/images/Custom-web-development@2x.png"
import IT from "../../assets/images/IT consultancy@2x.png"
import support from "../../assets/images/Maintanence-support@2x.png"
import QA from "../../assets/images/QA@2x.png"
import UI from "../../assets/images/ux_ui-design@2x.png"

export const cardData = [
    {
        icon: mobile,
        five: "Custom Mobile Development",
        para: "From blueprint, to design, to coding.. we've got your back! We can build your customer facing or internal use mobile app for iOS or Android (most people do both).Once you've approved your first version for launch we handle the Apple and Google submission process for you.",
        color: "#FFDB7C"
    },
    {
        icon: web,
        five: "Custom Web Development",
        para: "Many mobile app clients also choose to make their software available as a web app, and some only need a web software. Going with a web-only software is most common for custom internal company tools that are not consumer facing.",
        color: "#C1AEF8"
    },
    {
        icon: IT,
        five: "IT Consultancy",
        para: "We offer consultation in each and every aspect that makes your transformation to the digital world easier. It includes, discovery calls, idea brainstorming, process understanding and strategy development.",
        color: "#58CBFF"
    },
    {
        icon: support,
        five: "IT Maintenance & Support",
        para: "One of the biggest questions we get is can you help maintain the app after it's built?. The answer is ABSOLUTELY. We can host, maintain, and continuously upgrade your app. In fact, we prefer to work with clients who have long term plans for their app. Consider us YOUR development partner.",
        color: "#FF8A8A",
    },
    {
        icon: QA,
        five: "QA/Testing",
        para: "Our QA team is well versed in what they do. We follow a process that includes functional/non-functional testing, unit testing, security testing, integration/regression testing and user acceptance testing.",
        color: "#23d9ae"
    },
    {
        icon: UI,
        five: "UI/UX Design",
        para: "We understand the primary importance of interface design and user experience and We will help you out transforming the most friendly way of interaction between user and software.",
        color: "#F8AEC3"
    },
]
